import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateEmployeeModel,
  DeleteEmployeeModel,
  EditEmployeeModel,
  SearchEmployeeModel,
} from '../../../models/employee.model'

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Funcionario'

  constructor(private httpClient: HttpClient) {}

  public createEmployee(
    model: any,
    // model: CreateEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editEmployee(
    // model: any,
    model: EditEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteEmployee(
    model: DeleteEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedEmployee(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listAllPagedEmployee(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listallpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedEmployeeConsultant(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/consultor?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listEmployee(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getEmployeebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedEmployee(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchAllPagedEmployee(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/searchall-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedEmployeeConsultantOperate(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/consultor-operacional?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedClientsAssociateByEmployeeId(
    page: number,
    rows: number = 15,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listallpaginated/associados/funcionario/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedClientsAssociateByEmployeeId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/searchall-paginated/associados/funcionario/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedClientsNotAssociateByEmployeeId(
    page: number,
    rows: number = 15,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listallpaginated/nao-associados/funcionario/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedClientsNotAssociateByEmployeeId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/searchall-paginated/nao-associados/funcionario/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createAssociateClientsEmployee(
    model: any,
  ): Observable<ResponseRequestModel> {
    /* Model
{
  "clienteId": 0,
  "funcionarioId": 0
}
     */
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/cliente-consultor-operacional`,
      model,
    )
  }

  public deleteAssociateClientsEmployee(
    model: any,
  ): Observable<ResponseRequestModel> {
    /* Model
{
  "clienteId": 0,
  "funcionarioId": 0
}
     */
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/cliente-consultor-operacional`,
      model,
    )
  }

  public updateEmailEmployee(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit/email`,
      model,
    )
  }
  public listPagedConsultantOperateAssociateByCLientId(
    page: number,
    rows: number = 15,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Cliente/listpaginated/associados/cliente/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedConsultantOperateNotAssociateByCLientId(
    page: number,
    rows: number = 15,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}Cliente/listpaginated/nao-associados/cliente/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedConsultantOperateNotAssociateByCLientId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Cliente/search-paginated/nao-associados/cliente/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedConsultantOperateAssociateByCLientId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idEmployee: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Cliente/search-paginated/associados/cliente/${idEmployee}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedEmploeyeeOperate(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/consultor-operacional?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
